import { Component, Vue, Watch } from 'vue-property-decorator';
import { setAuthToken, setUserId, setUserName } from '@/utils/cookies';

import { Regexp } from '@/utils/validate';
import { Login } from '@/api/index';

@Component
export default class LoginEdit extends Vue {
  private loginInfo: any = {
    username: '',
    password: '',
    captcha: '',
    captchaId: new Date().getTime()
  };
  private invalid: boolean = true;
  private remberChecked: boolean = false;
  private loginButton: any = {
    title: '登录',
    icon: ''
  };

  // 表单验证规则
  get rules(): object {
    return {
      username: [ Regexp().required ],
      password: [ Regexp().required ],
      captcha: [ Regexp().required ]
    };
  }

  // 实时验证表单 判断确定按钮是否可用
  private validateForm() {
    this.invalid = (this.$refs.loginForm as any).fields.some((e: any) =>
      e.isRequired ? e.validateState !== 'success' : e.validateState === 'error'
    );
  }

  // 刷新验证码
  private refresh(): void {
    this.loginInfo.captchaId = new Date().getTime();
  }

  // 登录按钮
  private loginClick() {
    this.loginButton.title = '登录中';
    this.loginButton.icon = 'el-icon-loading';
    this.invalid = true;
    const params: any = {
      username: this.loginInfo.username,
      password: this.loginInfo.password,
      verifyCode: this.loginInfo.captcha,
      rememberMe: this.remberChecked
    };
    Login.login(params).then((res: any) => {
      setAuthToken(res.data.authToken);
      setUserId(res.data.userId);
      setUserName(res.data.username);
      // 跳转路由
      this.$router.push({ path: '/' });
    }).catch((error: any) => {
      this.loginInfo.password = '';
      this.loginInfo.captcha = '';
      this.loginButton.title = '登录';
      this.loginButton.icon = '';
      this.refresh();
    });
  }
  private remberChange() {
    this.remberChecked = !this.remberChecked;
  }
}
